import React, { useMemo, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import api from "../../api";

const BOARD_URL = "/Achievements.png";
const BOARD_W = 320;
const BOARD_H = 224;

const Achievements = ({ embedded = false }) => {
  if (!embedded) {
    document.title = "Pokémon Radiance | Achievements";
  }

  const [boardState, setBoardState] = useState({
    board: { url: BOARD_URL, w: BOARD_W, h: BOARD_H },
    badges: [],
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/v1/achievements/board", { withCredentials: true });
        if (!cancelled && res?.data) {
          setBoardState({
            board: res.data.board || { url: BOARD_URL, w: BOARD_W, h: BOARD_H },
            badges: Array.isArray(res.data.badges) ? res.data.badges : [],
          });
        }
      } catch (e) {
        if (!cancelled) {
          setBoardState({ board: { url: BOARD_URL, w: BOARD_W, h: BOARD_H }, badges: [] });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const badges = useMemo(() => boardState.badges || [], [boardState.badges]);

  const toPct = (px, axisMax) => `${(Number(px) / axisMax) * 100}%`;

  const boardUrl = boardState?.board?.url || BOARD_URL;
  const boardW = Number(boardState?.board?.w || BOARD_W);
  const boardH = Number(boardState?.board?.h || BOARD_H);

  const board = (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "min(92vw, 720px)",
          aspectRatio: `${boardW} / ${boardH}`,
          backgroundImage: `url(${boardUrl})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          imageRendering: "pixelated",
        }}
      >
        {badges.map((b) => (
          <img
            key={b.id}
            src={b.icon}
            alt={b.name}
            title={b.name}
            style={{
              position: "absolute",
              left: toPct(b.x, boardW),
              top: toPct(b.y, boardH),
              width: toPct(b.w, boardW),
              height: toPct(b.h, boardH),
              imageRendering: "pixelated",
            }}
          />
        ))}
      </div>
    </div>
  );

  if (embedded) {
    return board;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Profile" breadcrumbItem="Achievements" />
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>{board}</CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Achievements;
